<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title" v-text="pageTitle"></h1>
      </template>
      <template #actions>
        <page-header-action @click.prevent="backToDeployment">
          Back to deployment
        </page-header-action>
        <page-header-action @click.prevent="toggleNotes">
          Notes
        </page-header-action>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <hire
            :hire="hireData"
            :incident="incident"
            :modal-view="true"
            :readonly="readonly"
          ></hire>
          <!--<div class="card-footer text-right">-->
          <!--<button class="btn btn-primary btn-raised" name="save" v-on:click.prevent="submit">-->
          <!--<i class="icon icon-save"></i> Save-->
          <!--</button>-->
          <!--</div>-->
        </div>
      </div>
    </div>

    <notes-window
      :show="notes"
      :incident="incident"
      v-on:toggle-note="toggleNotes"
    ></notes-window>
  </div>
</template>

<script>
import Notes from './../Shared/Notes.vue';
import Hire from './Children/AddHire.vue';
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    party: {
      type: String,
      required: true
    },

    hire: {
      type: String,
      required: true
    }
  },

  components: {
    PageHeader,
    PageHeaderAction,
    'notes-window': Notes,
    hire: Hire
  },

  computed: {
    pageTitle() {
      if (this.clientData.full_name) {
        return 'Deployment For Client: ' + this.clientData.full_name;
      }

      return 'Deployment';
    },
    readonly() {
      return this.isReadonly();
    }
  },

  data() {
    return {
      indicator: false,
      currentView: 'hire',
      notes: false,
      clientData: {},
      addHire: false,
      hireData: {},
      tabs: [
        {
          name: 'hire',
          label: 'Hire'
        },
        {
          name: 'storage',
          label: 'Storage'
        },
        {
          name: 'recovery',
          label: 'Recovery'
        },
        {
          name: 'personal_injury',
          label: 'Personal Injury'
        },
        {
          name: 'salvage',
          label: 'Salvage'
        }
      ]
    };
  },

  mounted() {
    window.Ajax.get(`/incidents/${this.incident}/client`)
      .then(response => {
        this.clientData = response.data;
      })
      .catch(error => {});

    window.Ajax.get(
      `/incidents/${this.incident}/parties/${this.party}/hires/${this.hire}`
    )
      .then(response => {
        this.hireData = response.data;
      })
      .catch(error => {});
  },

  methods: {
    viewHireForm() {},

    showAddHireForm() {
      this.indicator = true;

      window.Ajax.post(
        `/incidents/${this.incident}/parties/${this.party}/hires`
      )
        .then(response => {
          this.indicator = false;
          this.route(
            `/deployment/${this.incident}/party/${this.party}/hire/${response.data.identifier}`
          );
        })
        .catch(error => {
          this.indicator = false;
          window.toastify.error(
            'Error',
            'Sorry, there was an issue creating the hire'
          );
        });
    },

    closeModal() {
      this.addHire = false;
    },

    setActive() {},

    backToDeployment() {
      this.route(`/deployment/${this.incident}`);
    },

    toggleNotes() {
      this.notes = !this.notes;
    }
  }
};
</script>
